import Splide from '@splidejs/splide';

export function sliders() {

  const initSliders = () => {

    const slidesToScroll = 1;
    const slidesToShow = 3;
    const slidesToShowSmall = 2;
    const slidesToShowMobile = 1;
    let slidesToCheck = slidesToShow;

    const newsSlider = new Splide( '.splide', {
      perMove: slidesToScroll,
      perPage: slidesToShow,
      arrows: false,
      pagination: false,
      drag: true,
      lazyLoad: 'nearby',
      gap: 30,
      breakpoints: {
        1440: {
          perPage: slidesToShowSmall,
          gap: 20,
        },
        768: {
          perPage: slidesToShowMobile,
          gap: 16,
        },
      }
    }).mount();

    document.getElementById('latestNewsSlider').closest('.slider-wrapper').querySelector('.slider-prev').addEventListener('click', (e) => {

      document.getElementById('latestNewsSlider').closest('.slider-wrapper').querySelector('.slider-next').classList.remove('disabled');

      newsSlider.go('<');
      if(newsSlider.index == 0) {
        e.currentTarget.classList.add('disabled');
      }
      else {
        e.currentTarget.classList.remove('disabled');
      }
    });

    document.getElementById('latestNewsSlider').closest('.slider-wrapper').querySelector('.slider-next').addEventListener('click', (e) => {

      document.getElementById('latestNewsSlider').closest('.slider-wrapper').querySelector('.slider-prev').classList.remove('disabled');

      if(window.innerWidth <= 768) {
        slidesToCheck = slidesToShowMobile;
      }
      else if(window.innerWidth <= 1440) {
        slidesToCheck = slidesToShowSmall;
      }
      else {
        slidesToCheck = slidesToShow;
      }

      newsSlider.go('>');
      if((newsSlider.index + (slidesToCheck - 1)) >= newsSlider.length - 1) {
        e.currentTarget.classList.add('disabled');
      }
      else {
        e.currentTarget.classList.remove('disabled');
      }
    });

  }

  document.addEventListener( 'DOMContentLoaded', function() {
    initSliders();
  });

}


// WEBPACK FOOTER //
// ./assets/js/modules/sliders.js